import React from 'react'
import GalleryComponent from '../../components/GalleryComponent/GalleryComponent'
import { Link } from 'react-router-dom'

import gallery_1 from '../../assets/images/horton-1.jpg'
import gallery_2 from '../../assets/images/horton-2.webp'
import gallery_3 from '../../assets/images/horton-3.webp'
import gallery_4 from '../../assets/images/horton-4.webp'
import gallery_5 from '../../assets/images/horton-5.webp'
import gallery_6 from '../../assets/images/horton-6.jpg'
import gallery_7 from '../../assets/images/horton-7.jpg'
import gallery_8 from '../../assets/images/horton-8.jpg'
import gallery_9 from '../../assets/images/horton-9.jpg'
import gallery_10 from '../../assets/images/horton-10.jpg'
import gallery_11 from '../../assets/images/horton-11.jpg'
import gallery_12 from '../../assets/images/horton-12.jpg'
import gallery_13 from '../../assets/images/horton-13.jpg'
import gallery_14 from '../../assets/images/horton-14.jpg'
import gallery_15 from '../../assets/images/horton-15.webp'

const wildlife_photography = () => {

    const items = [
        { xs: 5, imgSrc: gallery_1 },
        { xs: 3.5, imgSrc: gallery_2 },
        { xs: 3.5, imgSrc: gallery_3 },
        { xs: 3.5, imgSrc: gallery_4 },
        { xs: 3.5, imgSrc: gallery_5 },
        { xs: 5, imgSrc: gallery_6 },
        { xs: 3.5, imgSrc: gallery_7 },
        { xs: 3.5, imgSrc: gallery_8 },
        { xs: 5, imgSrc: gallery_9 },
        { xs: 4, imgSrc: gallery_10 },
        { xs: 4, imgSrc: gallery_11 },
        { xs: 4, imgSrc: gallery_12 },
        { xs: 5, imgSrc: gallery_13 },
        { xs: 3.5, imgSrc: gallery_14 },
        { xs: 3.5, imgSrc: gallery_15 },
    ];

  return <div className='__black'>
    <div className="safari__blog-content w-1">
        <h1 className="__h1">Horton Plains National Park</h1>
        <span class="dash"></span>
          <p>Welcome to Horton Plains National Park, a pristine natural gem nestled in the central highlands of Sri Lanka. Renowned for its breathtaking landscapes and diverse wildlife, the park is a haven for nature enthusiasts and adventure seekers a like.</p>

          <h2>Main Attraction : Montane Leopards</h2>
          <p>Horton Plains is home to the elusive and majestic Montane Leopards. These rare and endangered big cats roam the montane grasslands, adding an element of thrill to the park’s allure. Visitors may be fortunate enough to catch a glimpse of these elusive creatures as they navigate their natural habitat</p>
          
          <h2>Avian Wonders : Migrant and Endemic Birds</h2>
          <p>The park boasts a rich avian population, attracting both migrant and endemic species. Birdwatchers will delight in spotting vibrant migrants like the Pied Thrush and the Kashmir Flycatcher, alongside a plethora of endemic species such as the Sri Lanka Whistling Thrush and the Yellow-eared Bulbul.</p>

          <h2>Biodiversity Beyond : Reptiles and Amphibians</h2>
          <p>Horton Plains is not just a haven for mammals and birds but also a sanctuary for reptiles and amphibians. From vibrant frogs to unique reptilian species, the park’s ecosystems support a remarkable diversity of cold-blooded creatures, contributing to the overall biodiversity of the region.</p>
          
          <h2>Park Details :</h2>
          <p>Horton Plains National Park, situated approximately 200 kilometers east of Colombo, is easily accessible by road. The drive from Colombo takes around 5-6 hours, offering scenic views of Sri Lanka’s diverse landscapes. Once at the park, visitors can embark on an exploration of the stunning World’s End, a sheer cliff with panoramic views, and Baker’s Falls, a picturesque waterfall surrounded by lush greenery.</p>
          
          <h2>Duration and Recommendations :</h2>
          <p>A visit to Horton Plains National Park is ideally a full-day excursion. To fully appreciate the beauty and diversity of the park, allocate sufficient time for trekking and exploration. It’s advisable to start your journey early in the morning to witness the park’s enchanting landscapes come to life.</p>
          
          <p>Prepare for a day of adventure, as Horton Plains National Park promises an immersive experience in Sri Lanka’s natural wonders, from its iconic leopards to the vibrant birdlife and diverse ecosystems that make this park a must-visit destination for nature enthusiasts.</p>

        <Link class="wildlife__plan-link" to='/contact'>Plan Your Tour</Link>
    </div>
    <div className="w-1">
        <GalleryComponent imgStyle={{padding:'10px', height:'40vh'}} items={items} />;
    </div>
  </div>
}

export default wildlife_photography